import {
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST_ERROR,
  NOTIFICATION_LIST
} from "../actions/types"

var initialState = {
  notifications: [],
  loading: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        loading: action.payload.loading
      }
    case NOTIFICATION_LIST_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: action.payload.loading
      }
    case NOTIFICATION_LIST:
      return {
        ...state,
        notifications: action.payload.notifications,
        loading: action.payload.loading
      }
    default:
      return { ...state }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/notification_list_reducer.js
 **/